// extracted by mini-css-extract-plugin
export default {"form":"FirstQuestionSlide_form-QkR","said":"FirstQuestionSlide_said-waL","bubble":"FirstQuestionSlide_bubble-YOV","question":"FirstQuestionSlide_question-fTT"};